module.exports = __webpack_public_path__ + "spine/building_celebration_3x3.json?6ac60a817b6fe21903b256b38b8232f4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spine/building_construction/building_celebration_3x3.json
// module id = 1752
// module chunks = 3